import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchAuthSession } from "aws-amplify/auth";
import { TestMfePage } from "@/pages/TestMfe/TestMfePage";

export const Route = createFileRoute("/test-mfe")({
  beforeLoad: async () => {
    try {
      const session = await fetchAuthSession();
      if (!session.tokens?.idToken) throw redirect({ to: "/login" });
    } catch (e) {
      if (e instanceof Error && e.name !== "Error") throw e;
      throw redirect({ to: "/login" });
    }
  },
  component: TestMfePage,
});
